import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["reel", "reelContainer", "result"];
  static values = {
    campaignId: String,
  };

  connect() {
    this.rowHeight = 48;

    fetch(`/api/v1/wins?campaign_id=${this.campaignIdValue}`, { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        this.items = data.items;
        console.log(data);

        // Start processing winners sequentially
        this.process();
      });
  }

  process() {
    if (!this.items || this.items.length === 0) return;

    // Initialize processing state if not exists
    if (!this.currentItemIndex) this.currentItemIndex = 0;
    if (!this.currentWinIndex) this.currentWinIndex = 0;

    const currentItem = this.items[this.currentItemIndex];

    // Check if current item has wins
    if (!currentItem.wins || currentItem.wins.length === 0) {
      this.moveToNextItem();
      return;
    }

    const currentWin = currentItem.wins[this.currentWinIndex];

    if (currentWin) {
      const itemId = currentItem.id;
      const itemName = currentItem.name;
      const userNames = currentItem.users;
      const winId = currentWin.id;
      const winUserName = currentWin.user;

      // Add item header to result target if it's the first win for this item
      if (this.currentWinIndex === 0 && this.hasResultTarget) {
        const itemHeader = document.createElement("h3");
        itemHeader.textContent = itemName;
        itemHeader.classList.add(
          "text-center",
          "h-12",
          "flex",
          "items-center",
          "justify-center",
        );
        this.resultTarget.appendChild(itemHeader);
      }

      this.populateReel(userNames);
      this.scrollToWinner(itemId, winId, userNames, winUserName);

      // Schedule next winner processing after animation completes
      setTimeout(() => {
        this.moveToNextWinner();
      }, 6000); // 5s animation + 1s buffer
    }
  }

  moveToNextWinner() {
    const currentItem = this.items[this.currentItemIndex];

    // Move to next win in current item
    this.currentWinIndex++;

    // If no more wins in current item, move to next item
    if (this.currentWinIndex >= currentItem.wins.length) {
      this.moveToNextItem();
    } else {
      // Process next win in current item
      this.process();
    }
  }

  moveToNextItem() {
    this.currentItemIndex++;
    this.currentWinIndex = 0;

    // If more items exist, continue processing
    if (this.currentItemIndex < this.items.length) {
      this.process();
    } else {
      // All winners completed - show congratulations
      this.showCongratulations();
    }
  }

  showCongratulations() {
    if (this.hasReelContainerTarget) {
      this.reelContainerTarget.innerHTML = "";
      const congratsHeader = document.createElement("h3");
      congratsHeader.textContent = "🎉 Congratulations 🎉";
      congratsHeader.classList.add(
        "text-center",
        "h-12",
        "flex",
        "items-center",
        "justify-center",
      );
      congratsHeader.setAttribute("data-controller", "confetti");
      this.reelContainerTarget.appendChild(congratsHeader);
    }
  }

  populateReel(names) {
    console.log("populateReel", names);
    if (this.hasReelTarget) {
      console.log(names);
      this.reelTarget.innerHTML = "";

      // Reset transform and remove transition before repopulating
      this.reelTarget.style.transition = "none";
      this.reelTarget.style.transform = "translateY(0px)";

      // Duplicate names for smooth scrolling effect
      for (let i = 0; i < 30; i++) {
        names.forEach((name) => {
          const div = document.createElement("div");
          div.textContent = name;
          div.className = "text-center h-12 flex items-center justify-center";
          this.reelTarget.appendChild(div);
        });
      }
    }
  }

  scrollToWinner(itemId, winId, userNames, winUserName) {
    console.log("scrollToWinner", itemId, winId, userNames, winUserName);
    if (this.hasReelTarget) {
      const indexInBlock = userNames.indexOf(winUserName);
      const totalRows = this.reelTarget.children.length;

      const visibleRowCount = 3; // assuming 3 visible rows (h-36 container, h-12 items)

      const winnerRow = totalRows - userNames.length + indexInBlock;
      const offset =
        winnerRow * this.rowHeight -
        this.rowHeight * Math.floor(visibleRowCount / 2);

      // Add a small delay to ensure the DOM is ready and reset is applied
      setTimeout(() => {
        this.reelTarget.style.transition =
          "transform 5s cubic-bezier(0.1, 0.6, 0.3, 1)";
        this.reelTarget.style.transform = `translateY(-${offset}px)`;
      }, 50); // Small delay to ensure reset takes effect
    }

    if (this.hasResultTarget) {
      setTimeout(() => {
        const winnerParagraph = document.createElement("p");
        winnerParagraph.textContent = `🎉 Winner: ${winUserName} 🎉`;
        winnerParagraph.classList.add(
          "text-center",
          "flex",
          "items-center",
          "justify-center",
        );
        this.resultTarget.appendChild(winnerParagraph);
      }, 5200);
    }
  }
}
